import { useMemo } from 'react'

import AnswerStreamProvider from '@/components/modules/chat/AnswerStreamProvider'
import ConversationSidebar from '@/components/modules/chat/ConversationSidebar'
import ConversationActionsCtx from '@/contexts/ConversationActionsContext'
import useConversations from '@/hooks/useConversations'
import { Outlet } from '@tanstack/react-router'

function ChatLayoutInner() {
  const { conversations, isLoading, refetch } = useConversations()
  const contextValue = useMemo(() => ({ refetchConversations: refetch }), [refetch])

  return (
    <ConversationActionsCtx.Provider value={contextValue}>
      <div className="relative flex min-h-0 flex-1">
        <ConversationSidebar conversations={conversations} isLoading={isLoading} />
        <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
          <Outlet />
        </div>
      </div>
    </ConversationActionsCtx.Provider>
  )
}

export default function ChatLayout() {
  return (
    <AnswerStreamProvider>
      <ChatLayoutInner />
    </AnswerStreamProvider>
  )
}
